<template>
    <v-dialog v-model="dialog" max-width="500" persistent>
        <v-card>
            <v-card-title>
                Crear etiqueta
                <v-spacer></v-spacer>
                <v-icon @click="hide">close</v-icon>
            </v-card-title>
            <v-card-text>
               <v-container>
                   <v-layout wrap>
                       <v-flex xs12>
                           <v-text-field
                                   label="Nombre"
                                   clearable
                                   filled
                                   :value="description | lowercase"
                                   @input="description = $event"
                           />
                       </v-flex>

                       <v-col cols="12" class="text-center">
                            <v-color-picker
                                class="mx-auto"
                              v-model="color"
                              hide-mode-switch
                              hide-inputs
                              />
                       </v-col>
                   </v-layout>
               </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="hide">cancelar</v-btn>
                <v-btn
                        :disabled="!description"
                        color="accent darken-1"
                        :loading="loadingSave"
                        @click="createLabel">crear</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {mapState, mapActions, mapMutations} from 'vuex'
    import {ApiUtils} from '@/utils/ApiUtils'

    export default {
        name: "LabelCreator",
        components: {},
        data(){
            return {
                description: '',
                color: '#FFF',
                type: 'client',
                dialog: false,
                loadingSave: false
            }
        },
        computed:{
          ...mapState(['currentProvider']),
        },
        methods:{
            ...mapActions(['fetchLabels']),
            ...mapMutations(['showSnackBar']),
            show(description = '', type = 'client'){
                const vm = this
                vm.description = description
                vm.type = type
                vm.dialog = true
            },
            hide(){
                const vm = this
                vm.dialog = false
            },
            async createLabel() {

                var vm = this

                const { id } = vm.currentProvider
                if (vm.loadingSave || !id) return

                vm.loadingSave = true
                let response = await ApiUtils.makePost(`providers/${id}/label`, {
                        description: vm.description.toLowerCase(),
                        color: vm.color,
                        type: vm.type,
                    })
                vm.loadingSave = false

                if (response.ok){
                    await vm.fetchLabels()
                    const json = await response.json()
                    vm.showSnackBar({
                        text: 'Etiqueta creada',
                        color: 'success'
                    })
                    await ApiUtils.fetchMe()
                    vm.$emit('created', json.result.label)

                }else{
                    const json = await response.json()
                    return vm.showSnackBar({
                        text: 'Error creando etiqueta: ' + json.message,
                        color: 'error'
                    })
                }

                vm.labelDescription = ''
                vm.labelColor = '#FFFFFF'
                vm.hide()

            }
        },
        watch:{
            dialog(val){
                const vm = this
                if(!val){
                    vm.description = ''
                }
            }
        }
    }
</script>

<style scoped>


</style>
